import PropTypes from 'prop-types';
import React from 'react';

class Countdown extends React.Component {
    constructor(props) {
        super(props);

        const now = new Date();
        const remainingTime = Math.floor((props.endMoment.valueOf() - now.valueOf()) / 1000);
        this.state = {
            timeLeft: remainingTime,
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            const nextTime = Math.floor(this.state.timeLeft - 1);
            if (nextTime === 0) {
                clearInterval(this.interval);
            }
            this.setState({
                timeLeft: nextTime,
            });
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.timeLeft !== this.state.timeLeft;
    }

    render() {
        return (
            <span>{this.state.timeLeft}secs</span>
        )
    }
}

Countdown.propTypes = {
    endMoment: PropTypes.object.isRequired,
};

export default Countdown;



// WEBPACK FOOTER //
// ./src/components/Countdown.jsx